import type { AuthMethod } from "types/analytics";
import { PENDING_AUTH_METHOD_KEY } from "@/constants";

export const setPendingAuthMethod = (method: AuthMethod): void => {
  sessionStorage.setItem(PENDING_AUTH_METHOD_KEY, method);
};

export const getPendingAuthMethod = (): AuthMethod | null => {
  return sessionStorage.getItem(PENDING_AUTH_METHOD_KEY) as AuthMethod | null;
};

export const clearPendingAuthMethod = (): void => {
  sessionStorage.removeItem(PENDING_AUTH_METHOD_KEY);
};
